/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface SemanticDomain
 */
export interface SemanticDomain {
  /**
   *
   * @type {string}
   * @memberof SemanticDomain
   */
  mongoId?: string | null;
  /**
   *
   * @type {string}
   * @memberof SemanticDomain
   */
  guid: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomain
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomain
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomain
   */
  lang: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomain
   */
  userId?: string | null;
  /**
   *
   * @type {string}
   * @memberof SemanticDomain
   */
  created?: string | null;
}
